<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="入库单" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5">
          <el-select v-model="query.type" placeholder="入库类型" clearable>
            <el-option label="采购入库" value="采购入库"></el-option>
            <el-option label="手工入库" value="手工入库"></el-option>
            <el-option label="盘盈" value="盘盈"></el-option>
            <el-option label="退货" value="退货"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-date-picker v-model="query.bill_time" type="date" value-format="yyyy-MM-dd" placeholder="单据日期"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">手工入库</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="类型" prop="type" width="110"></el-table-column>
        <el-table-column label="SKU" prop="skuId" width="100"></el-table-column>
        <el-table-column label="数量" prop="quantity" width="90"></el-table-column>
        <el-table-column label="成本单价" prop="costPrice" width="100"></el-table-column>
        <el-table-column label="来源单据" prop="sourceBill" width="150"></el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
        <el-table-column label="时间" prop="billTime" width="160"></el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="手工入库" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="类型">
          <el-select v-model="form.type" style="width: 100%">
            <el-option label="手工入库" value="手工入库"></el-option>
            <el-option label="盘盈" value="盘盈"></el-option>
            <el-option label="退货" value="退货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SKU" required>
          <el-select v-model="form.sku_id" filterable style="width: 100%">
            <el-option v-for="sku in skus" :key="sku.id" :label="(sku.skuCode || '') + ' ' + (sku.specJson || '')" :value="sku.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" required><el-input v-model.number="form.quantity" type="number"></el-input></el-form-item>
        <el-form-item label="成本单价"><el-input v-model.number="form.cost_price" type="number"></el-input></el-form-item>
        <el-form-item label="来源单据"><el-input v-model="form.source_bill"></el-input></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, type: '', bill_time: '' },
      list: [],
      total: 0,
      show: false,
      form: {},
      skus: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/skus', { params: { page: 1, limit: 500 } }).then(r => {
      if (r.data.status === 200) this.skus = r.data.data.records || []
    })
  },
  methods: {
    getData () {
      this.$axios.get('/stockIns', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.form = { type: '手工入库', sku_id: null, quantity: 1, cost_price: 0, source_bill: '', remark: '' }
      this.show = true
    },
    save () {
      if (!this.form.sku_id) { this.$message.warning('请选择SKU'); return }
      this.$axios.post('/stockIns', () => { this.show = false; this.getData() }, this.form)
    }
  }
}
</script>
